import createIcon from '../../createIcon';

/**
 * @component @name SelfImprovement
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOEMxMy4xMDQ2IDggMTQgNy4xMDQ1NyAxNCA2QzE0IDQuODk1NDMgMTMuMTA0NiA0IDEyIDRDMTAuODk1NCA0IDEwIDQuODk1NDMgMTAgNkMxMCA3LjEwNDU3IDEwLjg5NTQgOCAxMiA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDE2VjE0QzE4Ljc2IDE0IDE2Ljg0IDEzLjA0IDE1LjQgMTEuMzJMMTQuMDYgOS43MkMxMy42OCA5LjI2IDEzLjEyIDkgMTIuNTMgOUgxMS40OEMxMC44OSA5IDEwLjMzIDkuMjYgOS45NSA5LjcyTDguNjEgMTEuMzJDNy4xNiAxMy4wNCA1LjI0IDE0IDMgMTRWMTZDNS43NyAxNiA4LjE5IDE0LjgzIDEwIDEyLjc1VjE1TDYuMTIgMTYuNTVDNS40NSAxNi44MiA1IDE3LjQ4IDUgMTguMjFDNSAxOS4yIDUuOCAyMCA2Ljc5IDIwSDlWMTkuNUM5IDE4LjEyIDEwLjEyIDE3IDExLjUgMTdIMTQuNUMxNC43OCAxNyAxNSAxNy4yMiAxNSAxNy41QzE1IDE3Ljc4IDE0Ljc4IDE4IDE0LjUgMThIMTEuNUMxMC42NyAxOCAxMCAxOC42NyAxMCAxOS41VjIwSDE3LjIxQzE4LjIgMjAgMTkgMTkuMiAxOSAxOC4yMUMxOSAxNy40OCAxOC41NSAxNi44MiAxNy44OCAxNi41NUwxNCAxNVYxMi43NUMxNS44MSAxNC44MyAxOC4yMyAxNiAyMSAxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SelfImprovement = createIcon('SelfImprovement', [
  [
    'path',
    {
      d: 'M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z',
      key: '1u15gn',
    },
  ],
  [
    'path',
    {
      d: 'M21 16V14C18.76 14 16.84 13.04 15.4 11.32L14.06 9.72C13.68 9.26 13.12 9 12.53 9H11.48C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.16 13.04 5.24 14 3 14V16C5.77 16 8.19 14.83 10 12.75V15L6.12 16.55C5.45 16.82 5 17.48 5 18.21C5 19.2 5.8 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5C15 17.78 14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.21C18.2 20 19 19.2 19 18.21C19 17.48 18.55 16.82 17.88 16.55L14 15V12.75C15.81 14.83 18.23 16 21 16Z',
      key: 'mrysbz',
    },
  ],
]);

export default SelfImprovement;
